import React, { } from "react";
import HelpWindow from "./HelpWindow";
import { Typography } from "@mui/material";

export const Help_RunScenario = () => {
    return (
        <HelpWindow title="Run Scenario" >
            <Typography variant="body1" gutterBottom>
                Help for running a scenario

            </Typography>
        </HelpWindow>
    )
}


export const Help_RunSweep = () => {
    return (
        <HelpWindow title="Run Sweep" >
            <Typography variant="body1" gutterBottom>
                Help for running a sweep

            </Typography>
        </HelpWindow>
    )
}

export const Help_CompareScenario = () => {
    return (
        <HelpWindow title="Compare Scenarios" >
            <Typography variant="body1" gutterBottom>
                Help for comparing scenarios

            </Typography>
        </HelpWindow>
    )
}

export const Help_CustomChart = () => {
    return (
        <HelpWindow title="Custom Chart" >
            <Typography variant="body1" gutterBottom>
                Help for creating a custom chart

            </Typography>
        </HelpWindow>
    )
}